import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X6PageStore} from '../X6PageStore';

@observer
export class AddPushableBlockControls extends React.Component<{ store: X6PageStore }> {
  render() {
    const {store} = this.props;

    if (store.addPushableBlock === null)
      return null;

    const addPushableBlock = store.addPushableBlock;
    const isPending = addPushableBlock.save?.isPending === true;
    return (<>
      <div className="row justify-content-end" key="add-form-actions">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeAdd}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={addPushableBlock.save} align="right"/>
    </>);
  }
}
